// extracted by mini-css-extract-plugin
export default {"title":"MockupTabContent_title__oMSeO"};